export default async () => {
  const fetchConfigAndWriteToLocalStorage = async path => {
    const [hotelPath] = path.split("-local");
    const hotelPathForS3 = window.location.href.split("/")[2].split(".");
    hotelPathForS3.splice(0, 1);
    const domain = hotelPathForS3.join(".").split("-local")[0];
    const url = `https://s3-eu-west-1.amazonaws.com/${domain}/hotelSettings/${hotelPath}.json`;
    const fileRes = await fetch(url);
    return fileRes.json();
  };

  if (typeof window !== "undefined") {
    let hotelPath = window.location.href.split("/")[2];

    hotelPath = hotelPath.replace(`-staff.webee.app-local:${window.location.port === "" ? "80" : window.location.port}`, "-local");
    hotelPath = hotelPath.replace(`.staff.webee.app-local:${window.location.port === "" ? "80" : window.location.port}`, "-local");

    hotelPath = hotelPath.replace("-staff.webee.app", "");
    hotelPath = hotelPath.replace(".staff.webee.app", "");
    hotelPath = hotelPath.replace("-staffv2.webee.app", "");
    hotelPath = hotelPath.replace(".staffv2.webee.app", "");
    hotelPath = hotelPath.replace("-howa.home2nite.com", "");
    hotelPath = hotelPath.replace(".howa.home2nite.com", ".home2nite");
    hotelPath = hotelPath.replace("-travelbookgroup.app", "");
    hotelPath = hotelPath.replace(".travelbookgroup.app", ".travelbookgroup");

    try {
      if (typeof window !== "undefined" && hotelPath) {
        const hotelConfig = await fetchConfigAndWriteToLocalStorage(hotelPath);
        localStorage.setItem("hotelConfig", JSON.stringify(hotelConfig));
        return hotelConfig;
      }
    } catch (err) {
      console.error("Config fetch err", err);
      return null;
    }
  } else {
    console.error("window undefined");
    return null;
  }
};
